import { Alert, Box, Button, Container, Divider, LinearProgress, Stack } from '@mui/material'
import { DataGrid, GridCellParams, GridColDef, GridToolbar, GridValueFormatterParams, GridValueGetterParams } from '@mui/x-data-grid';
import { t } from 'i18next'
import React from 'react'
import { useHorseShoeing } from '../../hooks/useHorseShoeing';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { TUser } from '../../shared/types/user.type';
import DataGridActions from '../../components/global/DataGridActions';
import { setRiderItemToEdit, setRiderModal, setShoeingItemToEdit, setShoeingModal } from '../../store/reducers/modal.reducer';
import { isEmpty, toNumber } from 'lodash';
import I18nDataGrid from '../../components/global/I18nDataGrid';
import { useRiders } from '../../hooks/useRiders';
import { Add } from '@mui/icons-material';

function Riders() {
  const dispatch = useDispatch()
  const auth = useSelector<RootState>(state => state.user.user) as TUser | null
  const isUserLoading = useSelector<RootState>(state => state.user.isUserLoading) as boolean
  const { riders, isLoading, deleteRider, isDeleting } = useRiders(!isUserLoading, auth?.id)

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    {
      field: 'name',
      headerName: t('qualification:rider'),
      flex: 1,
      valueFormatter: (param: GridValueFormatterParams) => {
        return param.value ?? '-'
      }
    },
    {
      field: 'weight',
      headerName: t('parameters:weight') + '(KG)',
      align: 'left',
      flex: 1,
      valueFormatter: (param: GridValueFormatterParams) => {
        return (param?.value ?? 0) + ' kg'
      },
    },
    {
      headerName: t('settings:actions'),
      field: 'action',
      flex: 1,
      renderCell: (params: GridCellParams) =>
        <DataGridActions
          deleteTitle='riders:deleteRider'
          deleteSubtitle='riders:deleteRiderMessage'
          onEdit={() => {
            dispatch(setRiderItemToEdit(params.row))
            dispatch(setRiderModal(true))
          }}
          isDeleting={isDeleting}
          onDelete={() => { deleteRider(toNumber(params.id)) }}
        ></DataGridActions>
    }
  ];



  return (
    <Stack direction={'column'} spacing={2} >
      {
        !isEmpty(riders) && <Box  display={'flex'} justifyContent={'end'} height={'100%'}>
          <Button onClick={() => dispatch(setRiderModal(true))} variant='contained' startIcon={<Add></Add>}>{t('riders:addRider')}</Button>
        </Box>
      }
      <Divider ></Divider>
      <Alert severity='info'>
        {t('profileSectionDescription:riders')}
      </Alert>
      {(isLoading || isUserLoading) && <LinearProgress></LinearProgress>}
      <I18nDataGrid
        rows={riders}
        loading={(isLoading || isUserLoading)}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
          columns: {
            columnVisibilityModel: {
              id: false
            }
          }
        }}

        pageSizeOptions={[5]}
        checkboxSelection={false}
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: () => <Box  display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
            <Button onClick={() => dispatch(setRiderModal(true))} variant='contained' startIcon={<Add></Add>}>{t('riders:addRider')}</Button>
          </Box>
        }}
      />
    </Stack>
  )
}

export default Riders